export default __webpack_public_path__ + "static/media/element_87.fcdb0040.webp";